import * as types from "./ActionsUserReducer";

export default function userReducer(
    state = {
        user: null
    }, action) {
    switch (action.type) {
        case types.LOGIN_SUCCESS:
            state.user = action.value;
            break;
        case types.LOGIN_ERROR:
            state.user = "error";
            break;
        case types.LOGOUT:
            state.user = null;
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/user/UserReducer.ts